// Global
import { tv } from 'tailwind-variants';

export const tailwindVariants = tv({
  slots: {
    base: [
      'ContactForm',
      'py-spacing-spacing-5',
      'px-spacing-spacing-5',
      'md:py-spacing-spacing-10',
      'md:px-spacing-spacing-10',
    ],
    formWrapper: [
      'bg-themes-color-background-light',
      'rounded-themes-spacing-radius-large-general',
      'py-spacing-spacing-5',
      'px-spacing-spacing-5',
      'md:py-spacing-spacing-9',
      'md:px-spacing-spacing-9',
    ],
    formHeader: [
      'formHeader',
      '[&>h2]:text-themes-color-text-dark',
      '[&>h2]:text-header-large-xxSmall',
      '[&>h2]:font-header-large-xxSmall',
      '[&>h2]:leading-header-large-xxSmall',
      '[&>h2]:pb-spacing-spacing-5',
    ],
    formIntroduction: [
      'text-themes-color-text-dark',
      'text-header-large',
      'font-header-large',
      'leading-header-large',
      'pb-spacing-spacing-5',
    ],
    requiredColor: ['text-components-supporting-text-destructive'],
    requiredLabel: [
      'text-bodySans-large',
      'font-bodySans-large',
      'leading-bodySans-large',
      'text-themes-color-text-dark',
    ],
    errorMessageText: ['mt-1', 'text-sm', 'text-components-supporting-text-destructive'],
    horizontalBar: ['w-[73px] h-[4px] bg-[#d92c29] mb-spacing-spacing-5'],
    formContainerTop: ['grid', 'gap-y-spacing-spacing-8', 'pb-spacing-spacing-9'],
    formContainerBottom: ['formContainerBottom', 'grid', 'gap-y-spacing-spacing-8'],
    negativeSpace: ['-mt-6'],
    formContainerOneColumn: [
      'formContainerOneColumn',
      'grid',
      'grid-cols-1',
      'gap-x-spacing-spacing-5',
    ],
    formContainerTwoColumn: [
      'formContainerTwoColumn',
      'grid',
      'grid-cols-1',
      'md:grid-cols-2',
      'md:gap-x-spacing-spacing-5',
      'md:gap-y-0',
      'gap-x-0',
      'gap-y-spacing-spacing-8',
      'items-start',
    ],
    formFieldWrapper: ['form-field', 'flex', 'flex-col', 'gap-spacing-spacing-4'],
    formInputBox: [
      'border',
      'border-components-text-field-border-default',
      '!appearance-none',
      'active:border-components-button-color-outline-brand-focus-stroke',
      'bg-components-text-field-bg',
      'rounded-themes-spacing-radius-large-form-field-input',
      'py-components-text-field-input-padding-y',
      'px-components-text-field-input-padding-x',
      'text-bodySans-medium',
      'leading-bodySans-medium',
      'font-bodySans-medium',
      'h-[48px]',
      'w-full',
    ],
    formInputBoxTextArea: [
      'border',
      'border-components-text-field-border-default',
      'active:border-components-button-color-outline-brand-focus-stroke',
      'bg-components-text-field-bg',
      'rounded-[8px]',
      'py-components-text-field-area-input-padding-y',
      'px-components-text-field-area-input-padding-x',
      'min-h-[248px]',
      'w-full',
    ],
    inputLabel: [
      'text-bodySans-xSmall',
      'font-bodySans-xSmall',
      'leading-bodySans-xSmall',
      'text-components-supporting-text-default',
    ],
    inputSelect: [
      'pointer-events-none',
      'absolute',
      'right-4',
      'top-1/2',
      'transform',
      '-translate-y-1/2',
      'text-gray-500',
    ],
    inputCheckbox: [
      'text-bodySans-medium',
      'font-bodySans-medium',
      'leading-bodySans-medium',
      'text-components-supporting-text-default',
      '[&>a]:underline',
      '[&>a]:inline',
      '[&>a]:text-components-hyperlink-color-dark-default',
      '[&>a]:hover:text-components-hyperlink-color-dark-hover',
      '[&>a]:visited:text-components-hyperlink-color-dark-visited',
      '[&>a]:leading-none',
    ],
    UpcHelpImage: [
      'absolute',
      'cursor-pointer',
      'flex',
      'flex-col',
      'items-end',
      'mr-4',
      'md:mr-20',
      'hover:md:items-center',
      'mt-9',
      'justify-self-end',
      'md:justify-self-center',
      'group',
      'pb-3',
    ],
    BatchHelpImage: [
      'absolute',
      'cursor-pointer',
      'flex',
      'flex-col',
      'items-end',
      'mr-4',
      'hover:md:items-end',
      'mt-[9.75rem]',
      'md:mt-9',
      'justify-self-end',
      'group',
      'pb-3',
      'md:z-20',
    ],
    helpBoxRTE: [
      'text-bodySans-small',
      'font-bodySans-small',
      'leading-bodySans-small',
      'text-black',
      'relative',
      'z-10',
      'p-spacing-spacing-5',
      'gap-2',
      'bg-white',
      'border-radius-radius-1',
      'border-themes-color-stroke-light',
      'shadow-lg',
      'rounded-radius-radius-1',
      'mt-4',
      'w-[313px]',
      'hidden',
      'group-hover:block',
      'cursor-auto',
    ],
    arrowDropDown: ['[&>svg]:!fill-colors-grayscale-400'],
    submitButton: [
      'w-fit',
      'min-h-12',
      'cursor-pointer',
      'text-components-button-color-filled-brand-default-text',
      'hover:text-components-button-color-filled-brand-hover-text',
      'bg-components-button-color-filled-brand-default-bg',
      'hover:!bg-components-button-color-filled-brand-hover-bg',
      'gap-components-button-spacing-large-default-space-between',
      'py-components-button-spacing-large-default-padding-y',
      'px-components-button-spacing-large-default-padding-x',
      'rounded-themes-spacing-radius-large-button',
      'text-bodySans-medium-semibold',
      'font-bodySans-medium-semibold',
      'leading-bodySans-medium-semibold',
    ],
    submitButtonInvalid: [
      'bg-components-button-color-filled-brand-disabled-bg',
      'text-components-button-color-filled-brand-disabled-text',
      'cursor-not-allowed',
    ],
  },
});
